// ============= Imports =============
import { SignalRContextProps } from '@/contexts/SignalRContext';

// ============= Constants =============
// Hub name must match the hub name configured in SignalRContext
// SignalRContext uses 'userRelayHub' (lowercase, no 'message' in the name)
const HUB_NAME = 'userRelayHub';

// ============= Types =============
export interface AddClientToGroupUserSessionProps {
  invokeHub: SignalRContextProps['invokeHub'];
  userId: string;
}

// ============= Main Function =============
/**
 * Adds the client to a workspace group in UserMessageRelayHub
 * @param invokeHub Function to invoke SignalR hub methods
 * @param workspaceId The workspace ID to join
 * @returns Promise with API response or error
 */
export const addClientToGroupUserSession = async ({
  invokeHub,
  userId,
}: AddClientToGroupUserSessionProps): Promise<any> => {
  try {
    console.log(
      `🔄 Adding client to group [${userId}] in UserMessageRelayHub...`
    );

    if (!userId) {
      throw new Error('userId is required');
    }

    const result = await invokeHub<any>(
      HUB_NAME,
      'AddClientToUsersAsync',
      userId
    );

    console.log(`✅ Client added to group [${userId}] successfully`);
    return result;
  } catch (error) {
    console.error(
      `🔴 Error adding client to group [${userId}] in UserMessageRelayHub:`,
      error
    );
    throw error;
  }
};
